import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

function isDarkTheme() {
  return document.documentElement.dataset.theme === "business"
}

function themeColors() {
  const dark = isDarkTheme()
  return {
    text: dark ? "#a6adbb" : "#1f2937",
    grid: dark ? "rgba(166,173,187,0.15)" : "rgba(0,0,0,0.1)"
  }
}

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    type: { type: String, default: "line" },
    data: Object,
    options: { type: Object, default: {} }
  }

  connect() {
    if (this.hasCanvasTarget && this.hasDataValue) {
      this.createChart()
    }
    this.handleThemeChange = this.handleThemeChange.bind(this)
    document.addEventListener("theme-changed", this.handleThemeChange)
  }

  disconnect() {
    document.removeEventListener("theme-changed", this.handleThemeChange)
    this.destroyChart()
  }

  handleThemeChange() {
    if (this.chart) {
      this.destroyChart()
      this.createChart()
    }
  }

  dataValueChanged() {
    if (this.chart) {
      this.destroyChart()
      this.createChart()
    }
  }

  createChart() {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    const colors = themeColors()

    Chart.defaults.color = colors.text
    Chart.defaults.borderColor = colors.grid

    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      animation: reducedMotion ? { duration: 0 } : {},
      plugins: {
        legend: {
          display: this.typeValue === "doughnut" || this.typeValue === "pie",
          position: "bottom"
        }
      }
    }

    const mergedOptions = this.deepMerge(defaultOptions, this.optionsValue)

    this.chart = new Chart(this.canvasTarget, {
      type: this.typeValue,
      data: this.dataValue,
      options: mergedOptions
    })
  }

  destroyChart() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  deepMerge(target, source) {
    const result = { ...target }
    for (const key in source) {
      if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
        result[key] = this.deepMerge(result[key] || {}, source[key])
      } else {
        result[key] = source[key]
      }
    }
    return result
  }
}
